import { PlatformEnv } from 'src/constants';
import type { PlatformEnvValues } from 'src/types/platforms';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const STORE_NAME = 'PlatformEnv';

export type PlatformEnvStoreState = {
  platformEnv: PlatformEnvValues;
  setPlatformEnv: (platformEnv: PlatformEnvValues) => void;
};

const initialState = {
  platformEnv: PlatformEnv.STAGING,
};

export const usePlatformEnvStore = create<PlatformEnvStoreState>()(
  devtools(
    (set) => ({
      ...initialState,
      setPlatformEnv: (platformEnv) => set(() => ({ platformEnv })),
    }),
    { name: STORE_NAME },
  ),
);
